import type { IEventBus } from "@/domains/events"

import type { IVoteStore } from "./interfaces"
import { VoteOrchestrator } from "./vote-orchestrator"

export class VoteOrchestratorFactory {
  /**
   * Create a fully configured VoteOrchestrator
   */
  static create(voteStore: IVoteStore, eventBus: IEventBus): VoteOrchestrator {
    // 1. Create orchestrator with all dependencies
    const orchestrator = new VoteOrchestrator(voteStore, eventBus)

    // 2. Initialize orchestrator
    orchestrator.initialize()

    return orchestrator
  }
}
